import {Component, Input, OnInit} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-adx-invoice-details',
    templateUrl: './adx-invoice-details.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class AdxInvoiceDetailsComponent implements OnInit {
  @Input() data: any;
  invoiceData: any;
  constructor(private route: ActivatedRoute
  ) { }

  public ngOnInit(): void{
    if (this.data == null){
      this.route.paramMap.subscribe(params => {
        this.invoiceData = {
          adxInvoiceId: params.get('id'),
          pageSize: 25
        }
      });
    }
    else{
      this.invoiceData = {
        adxInvoiceId: this.data,
        pageSize: 25
      }
    }
  }
}
